<script setup lang="ts">
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

const onClick = (location) => {
  gsap.registerPlugin(ScrollToPlugin);
  gsap.to(window, { duration: 1, scrollTo: location });
};
</script>

<template>
  <div class="flex justify-center lg:mt-12 p-6 lg:p-0">
    <div>
      <button class="!normal-case" @click="onClick('#meeting-rooms')">
        {{ $t("spaces.meetingRooms.buttons.meetingRooms") }}
      </button>
      <button class="!normal-case" @click="onClick('#events')">
        {{ $t("spaces.meetingRooms.buttons.events") }}
      </button>
      <button class="!normal-case" @click="onClick('#coworking')">
        {{ $t("spaces.meetingRooms.buttons.coworking") }}
      </button>
      <button class="!normal-case" @click="onClick('#cafe')">
        {{ $t("spaces.meetingRooms.buttons.cafe") }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
button {
  border-radius: 0;
  background: black;
  color: white;
  margin: 4px;
  padding: 10px;
  font-weight: 300;
  font-size: 26px;
  transition:
    background-color 0.4s,
    color 0.4s;

  &:hover {
    background-color: $color-primary;
    color: black;
  }
}
</style>
